export const PATH_LOW_NPS_REASON_ADD = ''

export const REDUCER_NAME = 'feedback'



// WEBPACK FOOTER //
// ./src/modules/feedback/state/const.js